import { useDispatch, useSelector } from "react-redux";
import { showOtpLoginModal } from "../../Actions/VisualDataAction";
import { useState } from "react";
import Verification from '../Admin/IrLogin/Verification'
import Loading from "../Common/Loading";

const OtpLoginToContinue = () => {

    const dispatch = useDispatch();

    const otpLoginModal = useSelector(state => state.VisualData.otpLoginModal);

    const [loginDone, setLoginDone] = useState(false);

    if (!otpLoginModal?.open) return null;

    return (
        <div className={`itours-modal visible`}>
            <div
                className="modal-overlay"
                onClick={() => {
                    dispatch(showOtpLoginModal({
                        open: false,
                        phoneNumber: ""
                    }))
                }}
            />
            <div className="modal-inner modal-rounded xsmall-width">
                <button
                    type="button"
                    className="close-ir-login-modal"
                    onClick={() => {
                        dispatch(showOtpLoginModal({
                            open: false,
                            phoneNumber: ""
                        }))
                    }}
                >
                    <span className="itours-icon gray-close-icon" />
                </button>
                <div className="modal-main large-padding">
                    {loginDone ? (
                        <div>
                            <Loading />
                        </div>
                    ) : (
                        <Verification
                            userName={otpLoginModal.phoneNumber}
                            submitBtnText="ادامه"
                            successCallBack={() => { setLoginDone(true) }}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default OtpLoginToContinue;